import Component from '../../shared/component';

export default class PopupLink extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.bindEvents();
  }

  bindEvents() {
    this.handleClick = this.handleClick.bind(this);

    this.$element.on('click.PopupLink', this.handleClick);
  }

  unbindEvents() {
    this.$element.off('click.PopupLink', this.handleClick);
  }

  handleClick() {
    const url = this.$element.attr('href');
    const popupParams = [
      'scrollbars=yes',
      'menubar=no',
      'width=700',
      'height=600',
      'resizable=yes',
      'toolbar=no',
      'location=no',
      'status=no',
    ];

    window.open(url, '', popupParams.join(','));
  }
}
